export const SEARCH_BOX_PADDING = 0;
export const PAGE_TITLE_VARIANT = "h5";
export const PAGE_STACKS_SPACING = 1;
